export const MEMBER_INFO = 'user/info'
export const NOTICE = 'notice'
export const NOTICE_ACTION = 'worker/notice/action'
export const WORKER_NOTICE = 'worker/notices'
export const ACCOUNT_LINK_CREATE = 'account/link/create'
export const ACCOUNT_SEARCH = 'account/search'
export const ACCOUNT_SEARCH_LINK_CREATE = 'account/search/link-confirm'
export const CLIENT_INFO = 'user/clientinfo'
export const BANNERS = 'banners'
export const FEEDBACK = 'feedback'
export const UPDATE_COMM_PREF = 'communication-preference'
export const MEMBER_ACCESS_SEARCH = 'member-access/search'
export const MEMBER_ACCESS_RESTRICT = 'member-access/restrict'
export const MEMBER_ACCESS_UNRESTRICT = 'member-access/un-restrict'
export const GET_BANNERS_API = 'banner'
export const UPDATE_BANNER_API = 'banner'
export const SAVE_BANNER_API = 'banner'
export const UPDATE_BANNER_PRIORITY_API = 'banner/priority'
export const LOGOUT = 'user/logout'
export const CLEAR_SESSION = 'user/clearsession'
